import {Route, Routes} from 'react-router-dom';
import {CampaignCreationFunnel} from "../funnels/campaign-creation-funnel/campaign-creation-funnel";

export const FunnelCampaignsRoutes = () => {
  return (
    <Routes>
      <Route path="/:id/*" element={<CampaignCreationFunnel />} />
    </Routes>
  );
};
